var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#00BCDA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9991,
    cy: 16.0001,
    r: 11.7714,
    stroke: "#00BCDA",
    strokeWidth: 1.14286
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8598 14.4331C18.8598 15.9831 17.6033 17.2397 16.0532 17.2397C14.5031 17.2397 13.2465 15.9831 13.2465 14.4331C13.2465 12.883 14.5031 11.6264 16.0532 11.6264C17.6033 11.6264 18.8598 12.883 18.8598 14.4331Z",
    stroke: "#00BCDA",
    strokeWidth: 1.1102
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5229 18.9151L13.5213 18.914C12.3462 18.1501 11.6431 17.011 11.4056 15.6011L11.3276 15.1383H10.8582H8.2793H7.69781L7.72479 15.7191C7.83466 18.0842 9.35151 20.9904 12.2302 22.4267L12.2302 22.4267L12.2335 22.4283C15.2537 23.9104 18.2697 23.6917 21.0232 21.7139C23.0128 20.2893 24.0854 18.2795 24.3734 15.8502L24.4469 15.2297H23.8222H21.2379H20.7787L20.6926 15.6808C20.4471 16.9673 19.8543 17.8694 19.0858 18.4659C18.3138 19.0652 17.3305 19.3817 16.2686 19.4308C15.188 19.4251 14.2551 19.3948 13.5229 18.9151Z",
    stroke: "#00BCDA",
    strokeWidth: 1.1102
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small-logo.da04a568e5f57df80edd0b88ab80066d.svg";